import React, { CSSProperties, ReactNode, useState } from 'react';
import ContentRequestDialog, { ContentRequestMode } from '../../components/dialogs/governance/ContentRequestDialog/ContentRequestDialog';
import PageLayoutNew from '../../components/main/PageLayoutNew/PageLayoutNew';
import ContentGovernanceRouting, { routes } from './ContentGovernance.routing';
import { FolderPlus, Plus } from 'lucide-react';

type ContentGovernanceProps = {
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
    className?: string;
};

const ContentGovernance = (props: ContentGovernanceProps) => {
    const { className } = props;
    const [requestMode, setRequestMode] = useState<ContentRequestMode | null>(null);

    return (
        <PageLayoutNew
            routes={routes}
            name="Requests"
            pageName="Governance"
            className={className}
            headerActions={
                <div className="flex items-center gap-2">
                    <button className="btn-secondary flex items-center gap-2" onClick={() => setRequestMode('folder')}>
                        <FolderPlus size={16} />
                        Bulk Requests
                        <span
                            className="text-[10px] font-semibold px-1.5 py-0.5 rounded-full"
                            style={{ background: 'var(--accent-soft)', color: 'var(--accent)', letterSpacing: '0.04em' }}
                        >
                            Preview
                        </span>
                    </button>
                    <button className="btn-primary" onClick={() => setRequestMode('single')}>
                        <Plus size={16} />
                        New Request
                    </button>
                </div>
            }
        >
            <ContentGovernanceRouting />
            <ContentRequestDialog
                visible={requestMode !== null}
                defaultMode={requestMode ?? 'single'}
                onClose={() => setRequestMode(null)}
            />
        </PageLayoutNew>
    );
};

export default ContentGovernance;
